import React from 'react';
import getOptions from '../../../../utils/getOptions';
import { Space } from 'antd';
import CalculoCantidadDias from '../../../../utils/CalculoCantidadDias';
import MenuAcciones from '../Xinerlink/MenuAcciones';

export default function ContratosObraFaenaColumns(
  items,
  openedRecord,
  setOpenedRecord
) {
  items.forEach((index) => {
    if (index.tipoContrato === 'ContratoObraFaena') {
      index.tipoContrato = 'Obra o Faena';
    } else if (index.tipoContrato === 'ContratoPlazoFijo') {
      index.tipoContrato = 'Plazo Fijo';
    }
  });
  const ordenados = items.sort(
    (a, b) => parseInt(a.idOferta) - parseInt(b.idOferta)
  );

  return [
    {
      fixed: 'left',
      title: 'Nro Oferta',
      width: 100,
      dataIndex: 'idOferta',
      key: 'idOferta',
      filterSearch: true,
      filters: getOptions(ordenados, 'idOferta'),
      onFilter: (v, record) => record.idOferta.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      filterSearch: true,
      filters: getOptions(ordenados, 'nombre'),
      onFilter: (v, record) => record.nombre.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'RUT',
      dataIndex: 'dni',
      key: 'dni',
      filterSearch: true,
      filters: getOptions(ordenados, 'dni'),
      onFilter: (v, record) => record.dni.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Correo',
      dataIndex: 'correo',
      key: 'correo',
      filterSearch: true,
      filters: getOptions(ordenados, 'correo'),
      onFilter: (v, record) => record.correo.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Empresa Cliente',
      dataIndex: 'nombreEmpresa',
      key: 'nombreEmpresa',
      filterSearch: true,
      filters: getOptions(ordenados, 'nombreEmpresa'),
      onFilter: (v, record) => record.nombreEmpresa.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Razón Social Contratante',
      dataIndex: 'nombreEmpresaEmpleadora',
      key: 'nombreEmpresaEmpleadora',
      filterSearch: true,
      filters: getOptions(ordenados, 'nombreEmpresaEmpleadora'),
      onFilter: (v, record) => record.nombreEmpresaEmpleadora.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Fecha Inicio',
      dataIndex: 'fechaInicio',
      align: 'center',
      key: 'fechaInicio',
      filterSearch: true,
      filters: getOptions(ordenados, 'fechaInicio'),
      onFilter: (v, record) => record.fechaInicio.indexOf(v) === 0,
      render: (text, record) => <Space>{<div>{text}</div>}</Space>,
    },
    {
      title: 'Fecha Fin',
      dataIndex: 'fechaFin',
      align: 'center',
      key: 'fechaFin',
      filterSearch: true,
      filters: getOptions(ordenados, 'fechaFin'),
      onFilter: (v, record) => record.fechaFin.indexOf(v) === 0,
      render: (text, record) => <Space>{<div>{text}</div>}</Space>,
    },
    {
      title: 'Estado',
      dataIndex: 'estadoContrato',
      key: 'estadoContrato',
      filterSearch: true,
      filters: getOptions(ordenados, 'estadoContrato'),
      onFilter: (v, record) => record.tipoContrato.indexOf(v) === 0,
      render: (text, record) => (
        <Space>
          {CalculoCantidadDias(
            record.fechaInicio || '2023-01-01',
            record.estadoContrato
          ) ? (
            <div style={{ color: 'red' }}>{text}</div>
          ) : (
            <div>{text}</div>
          )}
        </Space>
      ),
    },
    {
      title: 'Acciones',
      align: 'center',
      fixed: 'right',
      render: (text, record) => (
        <Space>
          <MenuAcciones
            record={record}
            openedRecord={openedRecord}
            setOpenedRecord={setOpenedRecord}
          />
        </Space>
      ),
    },
  ];
}
